import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from '@gsa/afp-component-library';
import { useSolicitationActions } from '../components/apis/use-solicitation-actions';

const ArchiveSolicitationButton = ({ solicitation, ...rest }) => {
  const navigate = useNavigate();
  const { archiveSolicitation, archiveLoading } = useSolicitationActions({
    onCompleted: () => navigate('/catalog/solicitations'),
  });

  const onClick = () => {
    archiveSolicitation({
      variables: {
        id: Number(solicitation.id),
      },
    });
  };

  return (
    <Button
      variant="secondary"
      label="Archive"
      disabled={archiveLoading}
      onClick={onClick}
      {...rest}
    />
  );
};

ArchiveSolicitationButton.propTypes = {
  solicitation: PropTypes.shape({
    id: PropTypes.string,
    solicitationNumber: PropTypes.string,
  }).isRequired,
};

export default ArchiveSolicitationButton;
